import { render, staticRenderFns } from "./addFile.vue?vue&type=template&id=6915de2b&scoped=true&"
import script from "./addFile.vue?vue&type=script&lang=js&"
export * from "./addFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6915de2b",
  null
  
)

export default component.exports